module.exports = __webpack_public_path__ + "static/media/emailLink.ce4e4442.svg";